import React from "react";
import "./modal.css";
import { translate } from "reducers/i18n";

export const Modal = ({ children, title, handleClose, buttons, show }) => {
  return (
    <div className={"modal-outer modal-md" + (show ? " modal-show" : " modal-hidden")}>
      <div className={"modal-inner"}>
        <div className="modal-header d-flex justify-content-between">
          <b>{title}</b>

        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={handleClose}
            style={{ backgroundColor: "#dae0e5" }}
          >
            {translate("_cancel")}
          </button>
          {buttons}
        </div>
      </div>
    </div>
  );
};
